import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Footer from "./FooterLogin";
import API_URL from "../config";




const ServiciosCitas = () => {
  const navigate = useNavigate();
  const [servicios, setServicios] = useState([]);

  useEffect(() => {
    const fetchServicios = async () => {
      try {


        const res =await axios.get(`${API_URL}/api/servicios`);



        // solo servicios habilitados
        const serviciosActivos = res.data.filter((s) => s.habilitado === 1);
        setServicios(serviciosActivos);
      } catch (error) {
        console.error("Error al traer servicios", error);
      }
    };

    fetchServicios();
  }, []);

  const handleSeleccion = (servicio) => {
    // guardar colores del servicio para todo el sistema
    localStorage.setItem("colorServicio", servicio.color || "#1e3a8a");
    localStorage.setItem("fondoServicio", servicio.color_fondo || "#1e3a8a");

    navigate(servicio.ruta);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#f0f4ff", // fondo general de la página
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      {/* HEADER */}
      <header
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          padding: "30px 50px",
          backgroundColor: "rgba(255,255,255,0.1)",
          backdropFilter: "blur(8px)",
          color: "white",
        }}
      >
        <img src="/logo-dsm.png" alt="DSM" style={{ height: "60px" }} />
        <div>
          <h1 style={{ fontSize: "30px", fontWeight: "800" }}>
            Sistema de Citas
          </h1>
          <p style={{ opacity: 0.8 }}>Deutsche Schule Managua</p>
        </div>
      </header>

      {/* CONTENIDO */}
      <main
        style={{
          flex: 1,
          padding: "70px 20px",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: "32px",
            fontWeight: "700",
            marginBottom: "50px",
            color: "#1e3a8a",
          }}
        >
          Seleccione el servicio
        </h2>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "40px",
          }}
        >
          {servicios.map((servicio) => (
            <div
              key={servicio.id}
              onClick={() => handleSeleccion(servicio)}
              style={{
                width: "300px",
                borderRadius: "20px",
                overflow: "hidden",
                cursor: "pointer",
                transition: "all 0.3s ease",
                boxShadow: "0 15px 35px rgba(0,0,0,0.3)",
                background: servicio.color_fondo || servicio.color || "#ffffff", // ✅ fondo de la tarjeta
                color: "#fff", // texto blanco para contraste
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-10px)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0px)")}
            >
              {/* FRANJA COLOR SERVICIO */}
              <div
                style={{
                  height: "10px",
                  backgroundColor: servicio.color || "#2563eb",
                }}
              />

              {/* IMAGEN */}
              {servicio.imagen ? (
                <img

src={`${API_URL}${servicio.imagen}`}


                  alt={servicio.nombre}
                  style={{
                    width: "100%",
                    height: "180px",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <div
                  style={{
                    height: "180px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "60px",
                  }}
                >
                  📘
                </div>
              )}

              {/* CONTENIDO */}
              <div style={{ padding: "25px" }}>
                <h3
                  style={{
                    fontSize: "20px",
                    fontWeight: "700",
                    marginBottom: "10px",
                  }}
                >
                  {servicio.nombre}
                </h3>
                <p style={{ fontSize: "14px", color: "#fff" }}>
                  Haga clic para continuar
                </p>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* FOOTER */}
      <Footer colorFondo="rgba(0,0,0,0.2)" />
    </div>
  );
};

export default ServiciosCitas;